var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-header',[_c('div',{staticClass:"contents"},[_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.typeHash === '#normal' ? '编玩边学在线考试平台' : ' 蓝桥杯在线考试平台'))])])])}
var staticRenderFns = []

export { render, staticRenderFns }